import type { BillableWorkRM } from 'ab-requestModels/reportType/reportType.requestModel';

export const sortBillableWork = (a: BillableWorkRM, b: BillableWorkRM) => {
	return a.workName.localeCompare(b.workName, 'en');
};
